var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M305.8 0H158.7c-27 0-50.3 21.4-50.3 48.4v10.2h-9.3c-27 0-50.3 21.4-50.3 48.4v354.7c0 27 22.3 50.3 50.3 50.3h256c27 0 48.4-22.3 48.4-50.3v-9.3h11.2c27 0 48.4-22.3 48.4-50.3V157.3zm0 54.9 102.4 102.4H305.8zm58.7 406.8c0 5.6-3.7 10.2-9.3 10.2h-256c-5.6 0-10.2-4.7-10.2-10.2V108c0-4.7 4.7-9.3 10.2-9.3h9.3v314.6c0 27 13 40 40 40h216zm59.5-58.6c0 5.6-3.7 10.2-9.3 10.2h-256c-5.6 0-10.2-4.7-10.2-10.2V48.4c0-4.7 4.7-9.3 10.2-9.3h108v157.3H424z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyIcon);
export default ForwardRef;